import React from "react";
import { Link } from "react-router-dom";
import "./tabs.css";
import classNames from "classnames";
import { useLanguageContext } from "@/hooks";

const KgTabs = ({ menus, onClick }) => {

    const { language } = useLanguageContext();

    const handleTabChange = (tabIndex, clickedMenu) => {
        if (onClick) {
            onClick(tabIndex, clickedMenu);
        }
    }

    const createMenus = (menus, level = 0) => {
        if (menus && menus.length === 0) return null;
        return menus.map((menu, index) => {
            if (menu.menus && menu.menus.length > 0) {
                return (
                    <div className="dropdown" key={menu.key + index}>
                        {createLink(level, index, menu, 'dropdown-toggle')}
                        <ul className="dropdown-menu">
                            {createMenus(menu.menus, level + 1)}
                        </ul>
                    </div>
                );
            }
            return createLink(level, index, menu);
        })
    }

    const createLink = (level, index, menu, isDropdown) => {
        if (menu.hide) return null;
        if (isDropdown) return <Link key={index} to={menu.link} data-bs-toggle="dropdown" className={classNames('tab-btn btn rounded-pill px-3 py-2', { 'active': menu.active, 'dropdown-toggle': isDropdown })}>{language(menu.label) || menu.name} {menu.icon && (<i className={classNames('me-1', menu.icon)} />)}</Link>;
        const link = <Link onClick={() => handleTabChange(index, menu)} key={index} to={menu.link} className={classNames('px-3 py-2', { 'active': menu.active, 'tab-btn btn rounded-pill': level === 0 })}>{language(menu.label) || menu.name} {menu.icon && (<i className={classNames('me-1', menu.icon)} />)}</Link>;
        if (level > 0) return (<li className="dropdown-item" key={menu.key + index}>{link}</li>);
        return link;
    }

    return (
        <div className="d-inline-flex flex-row justify-content-end align-items-center gap-2">
            {createMenus(menus)}
        </div>
    );
}

export default KgTabs;